import getFeedRights from './getFeedRights';
import getFeedRoutes from './getFeedRoutes';
import getFeedSidebar from './getFeedSidebar';

const getFeedConfig = (type, params = {}) => ({
  routes: getFeedRoutes(type, params),
  rights: getFeedRights(type, params),
  sidebar: getFeedSidebar(type, params),
  type,
  topic: params?.topic,
  showTypeHeader: params?.showTypeHeader || false,
});

export default getFeedConfig;
